import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
// element
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import "animate.css";
import "./utils/rem";
import "@/assets/styles/common.less";
import "@/assets/font/font.scss";
import "swiper/css";
import ui from "./components/index.js";
createApp(App).use(store).use(router).use(ui).use(ElementPlus).mount("#app");
